import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicComponentsModule } from "src/components/ionic-components.module";
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { PipesModule } from "src/pipes/pipes.module";
import { CommonDirectiveModule } from "src/directive/common-directive.module";
import { FilterTextComponent } from "./filter-text/filter-text.component";
import { FilterDatePeriodComponent } from "./filter-date-period/filter-date-period.component";
import { FilterBarComponent } from "./filter-bar/filter-bar.component";
import { FilterNumberComponent } from "./filter-number/filter-number.component";
import { FilterPopupComponent } from "./filter-popup/filter-popup.component";
import { FilterSelectComponent } from "./filter-select/filter-select.component";
import { FilterTimeComponent } from "./filter-time/filter-time.component";

@NgModule({
    declarations: [
        FilterTextComponent,
        FilterDatePeriodComponent,
        FilterNumberComponent,
        FilterBarComponent,
        FilterPopupComponent,
        FilterSelectComponent,
        FilterTimeComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicComponentsModule,
        ReactiveFormsModule,
        TranslatePipe, TranslateDirective,
        PipesModule,
        CommonDirectiveModule
    ],
    exports: [
        FilterTextComponent,
        FilterNumberComponent,
        FilterDatePeriodComponent,
        FilterBarComponent,
        FilterPopupComponent,
        FilterSelectComponent,
        FilterTimeComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FilteromponentsModule { }
